import React from 'react'
import DatePicker, {registerLocale} from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import MessageUtils from '../../util/MessageUtils'
import ptBR from 'date-fns/locale/pt-BR'
import enUS from 'date-fns/locale/en-US'
import './DatePicker.css'
registerLocale('pt-BR', ptBR)
registerLocale('en-US', enUS)

// isClearable={true} raises onClickOutside (bug) hence cannot use

const DatePickerUI = ({context, messageList, selected, onChange, startOpen, onClickOutside, placeholderKey, placeholder,
    showTimeSelect, showTimeSelectOnly, timeIntervals = 5, minTime, maxTime}) =>
  <DatePicker
    className={showTimeSelectOnly ? 'w_datepicker w_datepicker_time_only' : 'w_datepicker'}
    startOpen={startOpen}
    selected={selected}
    onChange={onChange}
    onClickOutside={onClickOutside}
    placeholder={placeholder || (placeholderKey && MessageUtils.getMessageValue(messageList, placeholderKey))}
    isClearable={true}
    locale={locale(context)}
    dateFormat={
      showTimeSelectOnly
        ? 'h:mm aa'
        : showTimeSelect
          ? `${dateFormat(context)} h:mm aa`
          : dateFormat(context)
    }
    timeFormat={showTimeSelectOnly ? 'h:mm aa' : undefined}
    showTimeSelect={showTimeSelect || showTimeSelectOnly}
    showTimeSelectOnly={showTimeSelectOnly}
    timeIntervals={timeIntervals}
    minTime={minTime}
    maxTime={maxTime}
    popperClassName={showTimeSelectOnly ? 'w_datepicker_time_popper' : undefined}
  />

const locale = context => {
  let countryCode = context.account ? context.account.countryCode : context.session.countryCode
  switch (context.locale) {
    case 'en':
      return countryCode === 'CA' ? 'en-CA' : countryCode === 'GB' ? 'en-GB' : 'en-US'
    case 'ar':
      return countryCode === 'DZ' ? 'ar-DZ' : 'ar-SA'
    case 'fa':
      return 'fa-IR'
    case 'pt':
      return countryCode === 'BR' ? 'pt-BR' : 'pt'
    case 'zh':
      return countryCode === 'TW' ? 'zh-TW' : 'zh-CN'
    default:
      return context.locale
  }
}

const dateFormat = context => {
  return context.account ? context.account.dateFormat : context.session.dateFormat
}

export default DatePickerUI
